export default __webpack_public_path__ + "static/media/structurelab.a16e7071.png";